import UserSvg from 'assets/user.svg'
import { clsx } from 'clsx'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import ProfileStore from 'store/profile/ProfileStore'
import { store } from 'store/store'
import { styles } from 'util/style'
import AddSvg from './add.svg'
import DeleteSvg from './delete.svg'
import css from './StandProfileButton.module.scss'

type Props = {
  it: ProfileStore | undefined
  size?: number
}

export const StandProfileButton = observer(({ it, size = 108 }: Props) => {
  const selected = it && it.identity_id === store.profile.identity_id
  const picture = it?.picture
  const created = store.identities.profiles.reduce((r, it) => r + (it.identity_id ? 1 : 0), 0)
  const className = clsx(css.button, selected && css.selected)
  const vars = styles({ '--size': `${size}px` })
  const canDelete = !!it && created > 1

  const onSelect = useLatestCallback(() => {
    store.identities.open = false
    if (it === undefined) {
      controller.openCreateProfile()
    } else {
      controller.selectProfile(it)
    }
  })

  const onDelete = useLatestCallback(() => {
    if (it) controller.deleteProfile(it)
  })

  function icon() {
    if (picture) return <Img className={css.photo} src={picture} />
    if (it) return <UserSvg className={css.empty} width={24} height={24} />
    return <AddSvg className={css.dash} />
  }

  return (
    <Space className={className} style={vars} center>
      <Space className={css.content} center>
        {icon()}
      </Space>
      {selected && <Space className={css.white} />}
      <Space className={css.circle} onClick={onSelect} />
      {canDelete && <Space className={clsx(css.delete, css.var)} center onClick={onDelete}>
        <DeleteSvg />
      </Space>}
    </Space>
  )
})
